<script lang="ts">
	interface Props {
		videoSrc: string
		snapshotSrc: string
	}

	let { videoSrc, snapshotSrc }: Props = $props()
</script>

<div class="preview-container">
	<div class="img-container">
		<video class="preview" src={videoSrc} muted loop playsinline autoplay={true} preload="auto"
		></video>
		<img class="snapshot" src={snapshotSrc} alt="Calibrated snapshot" crossorigin="anonymous" />

		<svg width="0" height="0" style="position:absolute">
			<defs>
				<filter
					id="feather"
					filterUnits="objectBoundingBox"
					x="-0.2"
					y="-0.2"
					width="1.4"
					height="1.4"
				>
					<feGaussianBlur stdDeviation="0.004" />
				</filter>

				<mask id="wipe-mask" maskUnits="objectBoundingBox" maskContentUnits="objectBoundingBox">
					<rect x="0" y="0" width="1" height="1" fill="white" />
					<rect x="-.2" y="0" width=".2" height="1" fill="black" filter="url(#feather)">
						<animate
							attributeName="x"
							values="-0.2; 1.00; -0.2; -0.2"
							keyTimes="0; 0.4; 0.8; 1"
							calcMode="spline"
							keySplines="
								0.33 0 0.67 1;  
								0.33 0 0.67 1;  
								0 0 1 1         
							"
							dur="10s"
							repeatCount="indefinite"
						/>
					</rect>
				</mask>
			</defs>
		</svg>
	</div>
</div>

<style>
	video,
	img {
		position: absolute;
		object-fit: cover;
		width: 100%;
		height: 100%;
		background-color: black;
	}
	.snapshot {
		-webkit-mask: url(#wipe-mask);
		mask: url(#wipe-mask);
		-webkit-mask-repeat: no-repeat;
		mask-repeat: no-repeat;
		-webkit-mask-size: 100% 100%;
		mask-size: 100% 100%;
	}
	.img-container:hover svg {
		transform: translateY(100%);
	}

	img {
		mask: url(#logo-mask);
	}
</style>
